import * as Config from '../../../../../../config';
import React from 'react';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import Content from '../../../../common/Content';
import SubMenu from '../../../../common/SubMenu';
import GridCardActions from './GridCardActions';
import ListV2 from '../../../../content/list/ListV2';
// import RadioButton from '../../../../automix/RadioButton';
import Tracks from './Tracks';
import InfosRecommendations from '../../../../recommendation/InfosRecommendations';

import usePageScroll from '../../../../../../hooks/usePageScroll';

import './Container.css';

const MTOP = 12;
function ConnectedContainer({ dimension, pathCustom = '' }) {
  let { url } = useRouteMatch();
  const { width, height } = dimension;

  let { onScroll } = usePageScroll();

  const customFormatDataRecommendation = (data) => data.map(Config.formattedFromRecommendation(false));

  return (
    <div className={`global-page`} style={{ height }} onScroll={onScroll}>
      <Content name={`My Beatport`} isSticky={true} 
        stickyClassName={`global-sticky-menu`}
        contentClassName={`content-my-beatport`}
        styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
        subContent={(
          <div className='flexRow'>
            <div className={`flexRow slider-menu my-beatport-menu`}>
              <SubMenu to={`${url}/featured`} or={`${url}`} label={`Tracks`} />
              <SubMenu to={`${url}/artists`} label={`Artists`} />
              <SubMenu to={`${url}/labels`} label={`Labels`} />
              <SubMenu to={`${url}/recommendations`} label={`Recommendations`} />
            </div>
            <InfosRecommendations path={`${url}/recommendations`} />
            {/* {(!window.location.pathname.includes(`artists`) && !window.location.pathname.includes(`labels`)) && <RadioButton className={'discover-radio-button'} />} */}
          </div>
        )}
      >
        <Switch>
          <Route exact path={[`${url}`, `${url}/featured`]}>
            <Tracks pathApi={`/v4/my/beatport/tracks/?preorder=false&per_page=100${pathCustom}`} />
          </Route>
          <Route exact path={`${url}/artists`}>
            <GridCardActions id={`my-beatport-artists`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/v4/my/beatport/artists/`}
              type={`artist`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite artists to start a feed of new releases.'}
            />
          </Route>
          <Route path={`${url}/artists/:refresh`} render={ props => (
            <GridCardActions id={`my-beatport-artists${props.match.params.refresh}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/v4/my/beatport/artists/`}
              type={`artist`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite artists to start a feed of new releases.'}
            />
          )}/>
          <Route exact path={`${url}/labels`}>
            <GridCardActions id={`my-beatport-labels`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/v4/my/beatport/labels/`}
              type={`label`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite labels to start a feed of new releases.'}
            />
          </Route>
          <Route path={`${url}/labels/:refresh`} render={ props => (
            <GridCardActions id={`my-beatport-labels${props.match.params.refresh}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/v4/my/beatport/labels/`}
              type={`label`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite labels to start a feed of new releases.'}
            />
          )} />
          <Route exact path={`${url}/recommendations`}>
            <ListV2
              pathApi={`/catalog/v1/recommendations/user/?per_page=100`}
              customFormatData={customFormatDataRecommendation}
              loadMoreWithApi={false}
              sortable={false}
              id={`mybeatport-recommendations`}
              width={width}
              height={height - (Config.TAB_BAR_GUTTER * 5.8)}
              size={Config.LIST_ROW_HEIGHT}
              style={{paddingTop: 12}}
              isLoadMore={true}
              type={`Full`}
              orderBy={[`release`, `title`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
              filters={[`track_name`, `artists_s`, `label`, `genre_s`, `bpm`, `key`]}
              filtersStyle={{position: `absolute`, top: 20, right: 127}}
              panelStyle={{ margin: `0px 0px 16px 0px` }}
              automix={true}
              automixName={`Recommendations`}
              automixStyle={{ position: `absolute`, top: 21, left: `auto`, right: 0 }}
              from={`${url}/recommendations`}
              isBoost={true}
              cache={false}
              enableSave={true}
              saveName={`Recommendations: ${dayjs().format(`MMMM DD, YYYY`)}`}
            />
          </Route>
          <Route path={`${url}/collection`}>
            <ListV2
              pathApi={`/v4/my/downloads/?is_available_for_streaming=true&per_page=100`}
              sortable={false}
              id={`collection`}
              width={width}
              height={height - (Config.TAB_BAR_GUTTER * 5.3)}
              size={Config.LIST_ROW_HEIGHT}
              style={{paddingTop: MTOP}}
              isLoadMore={true}
              type={`Full`}
              orderBy={[`default`] /* API - Any WORKS */}
              filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `label`, `genre_s`, `bpm`, `key_convert`]}
              filtersStyle={{position: `absolute`, top: 12, right: 105}}
              panelStyle={{ top: 65 }}
              automix={true}
              automixName={`Collection`}
              automixStyle={{ position: `absolute`, top: 0, left: `auto`, right: 0 }}
              from={`/collection`}
            />
          </Route>
        </Switch>
      </Content>
    </div>
  );
}

ConnectedContainer.propTypes = {
  dimension: PropTypes.object
}

const Container = connect(
  state => ({
    dimension: state.dimension,
    pathCustom: state.MBPathCustom ? state.MBPathCustom : ''
  })
)(ConnectedContainer);

export default Container;
